import React, {useState} from "react";
import { HexColorPicker } from "react-colorful";

const ColorPicker = ({color,setColor}) => {
  return <HexColorPicker color={color} onChange={setColor} />;
};

export default ColorPicker;